import { useState } from 'react';
import { Input } from '../Input/Input';
import { Dropdown } from '../Dropdown/Dropdown';
import { Button } from '../buttons/Button/Button';
import { CheckForm } from '../CheckForm/CheckForm';
// import { ThankYouPage } from "./ThankYouPage";
import { senderCategory } from './assets';
import './form.scss';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';
import NewDropdown from 'components/Dropdown/NewDropdown';
// {
//     "menu_logo": "https://api-uniferx.goodface.com.ua/storage/logo.svg",
//     "menu_company_text": "Company",
//     "menu_products_text": "Products",
//     "menu_resources_text": "Resources",
//     "menu_contacts_text": "Contacts",
//     "menu_change_country_text": "Change country",
//     "menu_about_text": "About us",
//     "menu_news_text": "Research, news & events",
//     "menu_career_text": "Career",
//     "menu_all_products_btn": "All products",
//     "menu_crop_nutrition_text": "Crop nutrition programs",
//     "menu_trial_results_text": "Trial results",
//     "menu_information_materials_text": "Information materials",
//     "menu_all_resources_btn": "All Resources",
//     "menu_choose_country_text": "Please choose a country",
//     "menu_available_languages_text": "Available languages",
//     "menu_save_choice_text": "Save your choice",
//     "menu_search_placeholder": "Search placeholder",
//     "menu_clear_button_text": "Clear button",
//     "menu_search_results_text": null,
//     "menu_search_not_found_text": null,
//     "menu_search_products_text": null,
//     "menu_search_all_products_text": null,
//     "menu_search_resources_text": null,
//     "menu_search_all_resources_text": null,
//     "menu_search_nutrition_programs_text": null,
//     "menu_search_all_nutrition_programs_text": null,
//     "menu_search_trial_results_text": null,
//     "menu_search_all_trial_results_text": null,
//     "menu_search_posts_text": null,
//     "menu_search_all_posts_text": null,
//     "menu_search_vacancies_text": null,
//     "menu_search_all_vacancies_text": null,
//     "footer_description_text": "Ensuring safer harvests in an unsafer environment.",
//     "footer_social_media_text": "Social media",
//     "footer_instagram_link": "Instagram link",
//     "footer_facebook_link": "Facebook link",
//     "footer_youtube_link": "https://youtube.com/",
//     "footer_contacts_email_text": "info@uniferx.com",
//     "footer_contacts_phone_text": "+38 044 33 44 700",
//     "footer_contacts_address_text": "81 Turgenevska St., Kyiv, office. 1-А",
//     "footer_copyright_text": "Copyright © UniferX 2023",
//     "footer_terms_conditions_text": "Terms & Conditions",
//     "footer_legal_info_text": "Legal info",
//     "footer_cookie_policy_text": null,
//     "cookie_icon": null,
//     "cookie_title": null,
//     "cookie_description": null,
//     "cookie_btn": null,
//     "404_title": null,
//     "404_description": null,
//     "404_btn": null,
//     "other_show_more_button": null,
//     "sidebar_text_crop_nutrition": null,
//     "sidebar_text_trials_result": null,
//     "cta_description": null,
//     "cta_field_name_title": "Name",
//     "cta_field_name_placeholder": "Your name",
//     "cta_field_email_title": "E-mail",
//     "cta_field_email_placeholder": "Your E-mail",
//     "cta_field_phone_title": "Phone",
//     "cta_field_phone_placeholder": "Your phone number",
//     "cta_field_organization_title": "Organization",
//     "cta_field_organization_placeholder": "Organization",
//     "cta_field_sender_title": "Select a sender category*",
//     "cta_field_sender_options": [],
//     "cta_field_message_title": "Your message",
//     "cta_field_message_placeholder": "Please enter your message",
//     "cta_policy_text": "",
//     "cta_submit_button": "Submit",
//     "cta_thanks_title": null,
//     "cta_thanks_image": null,
//     "cta_thanks_description": null,
//     "cta_thanks_social_text": null
//   }
export const CTAForm = () => {
    const {
        cta_field_email_placeholder,
        cta_field_email_title,
        cta_field_message_placeholder,
        cta_field_message_title,
        cta_field_name_placeholder,
        cta_field_name_title,
        cta_field_organization_placeholder,
        cta_field_organization_title,
        cta_field_phone_placeholder,
        cta_field_phone_title,
        cta_field_sender_title,
        cta_policy_text,
        cta_field_sender_options,
        cta_submit_button,
    } = useSelector(selectTranslations);
    const [agreed, setAgreed] = useState(true);

    const onAgreed = value => {
        setAgreed(value);
    };
    const handleInputChange = e => {};

    const onSubmitForm = e => {
        e.preventDefault();
    };

    const options = cta_field_sender_options?.map(item => ({
        ...item,
        name: item.title,
    }));

    const [activeOption, setActiveOption] = useState(options?.[0]);

    const handleSelectChange = item => setActiveOption(item);

    return (
        <form onSubmit={onSubmitForm} className="form">
            <div className="content-form-wrapper">
                <div className="inputs-line">
                    <label>
                        <span className="body3">{cta_field_name_title}</span>
                        <Input type="text" placeholder={cta_field_name_placeholder} onChange={handleInputChange} />
                    </label>
                    <label>
                        <span className="body3">{cta_field_email_title}</span>
                        <Input type="email" placeholder={cta_field_email_placeholder} onChange={handleInputChange} />
                    </label>
                </div>
                <div className="inputs-line">
                    <label>
                        <span className="body3">{cta_field_phone_title}</span>
                        <Input type="tel" pattern="[0-9]*" placeholder={cta_field_phone_placeholder} name="phone" />
                    </label>
                    <label>
                        <span className="body3">{cta_field_organization_title}</span>
                        <Input placeholder={cta_field_organization_placeholder} />
                    </label>
                </div>
                <div className="form-dropdown">
                    <label>
                        <span className="body3">{cta_field_sender_title}</span>
                        <NewDropdown options={options} selectedValue={activeOption} onChange={handleSelectChange} />
                    </label>
                </div>
                <label>
                    <span className="body3">{cta_field_message_title}</span>
                    <textarea className="textarea" placeholder={cta_field_message_placeholder}></textarea>
                </label>
                <div className="submit-wrapper">
                    <div className="checkbox-wrapper">
                        <CheckForm onClick={onAgreed} checked={true}>
                            <span dangerouslySetInnerHTML={{ __html: cta_policy_text }} />
                        </CheckForm>
                    </div>
                    <div className="submit-button">
                        <Button type={`${!agreed && 'disabled'} submit`}>{cta_submit_button}</Button>
                    </div>
                </div>
            </div>
            {/* <ThankYouPage /> */}
        </form>
    );
};
